<template>
  <div id="btn-panel">
    <div id="download-btn-wrap">
      <div id="download-btn" @click="submit">
        <span>事例出力</span>
      </div>
    </div>
    <div style="text-align: right;font-size: x-small;">
      <p style="margin-bottom: 0;">NOI利回り（表面利回り）</p>
    </div>
    <!-- {{ selectList }} -->
    <div id="panel-wrap">
      <!-- {{ selectList }} -->
      <div v-for="(val, key) in selectList" :key="key" class="instance">
        <div class="instance-header">
          <div class="city-name-wrap">
            <div class="polygon-code-wrap">
              <div class="polygon-code">
                <div>{{ key + 1 }}</div>
              </div>
            </div>
            <div class="city-name">
              {{ val.pref_name }}{{ val.city_name }}{{ val.area_name }}
            </div>
          </div>
          <div class="delete-btn-wrap">
            <div class="delete-btn" @click="deleteHandler(key)">
              <span class="delete">X</span>
            </div>
          </div>
        </div>
        <div
          v-for="(rowVal, index) in val['data']"
          :key="index"
          class="instance-body-wrap"
        >
        <div
              v-if="
                (checkList.includes(rowVal.category_type))
                && (yearFrom <= rowVal.transaction_year)
                && (rowVal.transaction_year <= yearTo)
              "
              class="instance-body"
            >
              <!-- <div>
                <el-checkbox  class="checkbox">{{ rowVal.is_selected }}</el-checkbox>
              </div> -->
              <div>
                <input type="checkbox" id="checkbox" v-model="rowVal.is_selected">
              </div>
              <div>{{ rowVal.transaction_year }}年</div>
              <div>{{ rowVal.property_type }}</div>
              <div>{{ rowVal.structure }}</div>
              <div>{{ rowVal.built_at_year }}年築</div>
              <div>{{ rowVal.area_m2_range }}</div>
              <div>{{ rowVal.price_range }}</div>
              <div>{{ rowVal.noi_rate }}%</div>
              <div>({{ rowVal.gross_rate }}%)</div>
            </div>
          </div>
        </div>
        <!-- <div
          v-for="(data, bType) in val[annual]"
          :key="bType"
          class="instance-body-wrap"
        >
          <div
            v-if="
              data.Count != 0 &&
              checkList.includes(buildingTypeTextMapping[bType])
            "
            class="instance-body"
          >
            <div>{{ typeIdMapping[buildingTypeTextMapping[bType]] }}</div>
            <div>{{ data.Count }}事例</div>
            <div>{{ data.Rate }}%</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
const typeIdMapping = {
  1: "区分（単身向け）",
  2: "区分（ファミリー）",
  3: "一棟（木）",
  4: "一棟（非木）",
};

const buildingTypeTextMapping = {
  CondoSingle: 1,
  CondoFamily: 2,
  BuildingWood: 3,
  BuildingNotWood: 4,
};

import { getXlsxFile } from "@/api/imsb";

export default {
  Name: "Panel",
  methods: {
    submit: function () {
      this._getXlsxFile();
      this.$gtag.event("click", {
        event_category: "button_click",
        event_label: "事例出力ボタン",
      });
    },
    _getXlsxFile: function () {
      var ids = this.getIds();

      if (ids.length == 0) {
        return;
      }
      ids = JSON.stringify(ids);
      var checkList = JSON.stringify(this.checkList);

      getXlsxFile(ids, checkList, this.annual)
        .then((res) => {
          if (res.data.code === 200) {
            var link = document.createElement("a");
            // link.target = "_blank"
            link.href = res.data.data.url.Url;
            document.body.appendChild(link);
            link.download = "test";
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((err) => {
          this.$message.error(err.response.data.msg);
        });
    },
    getIds: function () {
      var ids = [];
      // console.log("getIds")
      for (let key in this.selectList) {
        // console.log(this.selectList[key])
        for (let data_key in this.selectList[key]['data']) {
          // console.log(this.selectList[key]['data'][data_key]['is_selected'])
          if (this.selectList[key]['data'][data_key]['is_selected']) {
            ids.push(this.selectList[key]['data'][data_key]['id']);
          }
        }
      }
      // console.log("getIds", ids)
      return ids;
    },
    deleteHandler: function (key) {
      this.$bus.$emit("deleteCheckList", key);
    },
  },
  props: {
    cityInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    checkList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectList: {
      type: Array,
      default: () => {
        return {};
      },
    },
    yearFrom: {
      type: Number,
      default: () => {
        return {};
      },
    },
    yearTo: {
      type: Number,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      annual: "",
      instanceList: {},
      buildingTypeTextMapping: buildingTypeTextMapping,
      typeIdMapping: typeIdMapping,
      panelCityInfo: {},
      panelSelectList: {},
    };
  },
  watch: {
    cityInfo: {
      handler(val) {
        this.panelCityInfo = val;
      },
      deep: true,
    },
    selectList: {
      handler(val) {
        console.log("aaaa");
        this.panelSelectList = val;
      },
      deep: true,
    },
  },
  created() {
    // this.$bus.$on("checkList", checkList => {
    //     this.checkList = checkList
    // })
    this.$bus.$on("annual", (annual) => {
      this.annual = annual;
    });
  },
  mounted() {},

  beforeDestroy() {
    this.$bus.$off("checkList");
    this.$bus.$off("annual");
  },
  watch: {},
};
</script>

<style scoped lang="scss">
#btn-panel {
  margin-left: 5px;
  display: flex;
  flex-direction: column;
}

#download-btn {
  font-family: "Hiragino Sans", "YuGothic", meiryo, メイリオ, osaka,
    "MS PGothic", arial, helvetica, sans-serif;
  font-weight: 400;
  width: 480px;
  height: 36px;
  background-color: var(--mdc-theme-secondary, #ee9d00);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 4px;

  &-wrap {
    margin-bottom: 4px;
    cursor: pointer;
  }

  & > span {
    color: white;
  }
}

.city-name {
  &-wrap {
    display: flex;
    width: 95%;
  }
}

.polygon-code {
  background-color: white;
  width: 12px;
  height: 60%;
  color: black;
  font-size: 12px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 3px;

  &-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
  }
}

#panel-wrap {
  height: 100%;
  overflow-y: auto;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.delete {
  &-btn {
    width: 16px;
    height: 16px;
    background-color: rgb(255, 51, 0);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.instance {
  &-header {
    color: white;
    background-color: rgb(0, 54, 91);
    display: flex;
    text-align: left;
    padding: 0 5px;

    &-item:nth-child(n + 2) {
      width: 25%;
    }
  }

  &-body {
    display: flex;
    justify-content: flex-start;
    text-align: left;
    padding-left: 5px;
    border-bottom: 1px solid rgb(0, 54, 91);
    border-left: 1px solid rgb(0, 54, 91);
    border-right: 1px solid rgb(0, 54, 91);
    min-height: 30px;
    align-items: center;

    & > div:nth-child(1) {
      width: 4%;
    }
    & > div:nth-child(12) {
      width: 13%;
    }

    & > div:nth-child(3) {
      width: 10%;
      // position: relative;
      padding-left: 4px;
    }

    & > div:nth-child(4) {
      width: 8%;
      font-size: xx-small;
    }

    & > div:nth-child(5) {
      width: 15%;
    }
    & > div:nth-child(6) {
      width: 13%;
    }
    & > div:nth-child(7) {
      width: 20%;
    }
    & > div:nth-child(8) {
      width: 10%;
    }
    & > div:nth-child(9) {
      width: 10%;
    }
  }
}
</style>
